import { IconNameType } from '@servicetitan/design-system';
import Task from './Task';
import { OutboundCallEntity } from '@lib/types/common-call-types';

export type TaskDirection = 'inbound' | 'outbound';

export enum AcceptedOnDevice {
  ThisDevice = 'thisDevice',
  OtherDevice = 'otherDevice',
}

export enum TaskState {
  Pending = 'PENDING',
  Offered = 'OFFERED',
  Rejected = 'REJECTED',
  Abandoned = 'ABANDONED',
  Accepted = 'ACCEPTED',
  WrapUp = 'WRAPUP',
  Completed = 'COMPLETED',
  TimedOut = 'TIMEDOUT',
}

export interface TaskOptions {
  id: string;
  tenantId?: string;
  from: string;
  to?: string;
  startedAt?: number;
  type: string;
  direction?: TaskDirection;
  state?: TaskState;
  displayName?: string;
  attributes?: Record<string, any>;
  recoveryStartedAt?: number | null;
  recoveryEndsAt?: number | null;
  queueName?: string;
  queueId?: string;
  isInternal?: boolean;
  isStateActive?: boolean;
}

export interface TransferStatus {
  inProgress: boolean;
  agentId: string;
  initiatedAt: Date;
  transferType: OutboundCallEntity;
  queueId?: string;
  queueName?: string;
}

export type CreateTaskOptions = TaskOptions;

export interface ITask {
  readonly id: string;
  readonly state: TaskState;
  readonly startedAt: Date;
  readonly type: string;
  readonly direction: TaskDirection;
  readonly from: string;
  readonly to?: string;
  readonly tenantId?: string;
  readonly displayName: string;
  readonly attributes: Record<string, any>;
  readonly recoveryStartedAt: number | null;
  readonly recoveryEndsAt: number | null;
  readonly queueName: string | undefined;
  readonly isInternal: boolean;
  readonly isStateActive: boolean;
  readonly loading: boolean;
}

export enum SkipClassificationReason {
  ClassificationCompleted = 'ClassificationCompleted',
  NotRequired = 'NotRequired',
  NoTenantAccess = 'NoTenantAccess',
}

export type HandleTaskHydrationFunction = (
  parsedTask: any,
  hydrateFn: (parsedTask: any) => Task,
) => Task | null;

export type TaskTypeDefinition = {
  key: string;
  category: string;
  categoryIcon?: IconNameType;
  types: string[];
  taskViewComponent: React.ComponentType<any>;
  taskRowComponent?: React.ComponentType<any>;
  taskSectionComponent?: React.ComponentType<any>;
  handleHydration?: HandleTaskHydrationFunction;
};
